import { useTranslation } from 'react-i18next'
import offline from '../../../src/assets/offline.svg'
import CloseTestConfirmation from '../../../src/components/CloseTestConfirmation/CloseTestConfirmation'
import Warning from '../../../src/components/Warning'
import InternetIssue from '../../components/InternetIssue/InternetIssue'
import PopUpWrapper from '../../components/PopUpWrapper/PopUpWrapper'
import Question from '../../components/Question/Question'
import QuestionHeader from '../../components/QuestionHeader/QuestionHeader'
import { isInPhoneOrTablet } from '../../utils/common/isInPhoneOrTablet'

function TestPanelUI({
    active,
    toggle,
    isPreview,
    isMock,
    connection,
    showGoBackPopUp,
    showWarningPopup,
    current_language,
    instructions,
    testpanel,
    handleSectionClick,
    tabSwitchCount,
    setActive,
    setShowWarningPopup,
    setShowGoBackPopUp,
    setDisconnectTime,
    handleGTagLogs,
    handleSubmit,
}) {
    const { t } = useTranslation()
    return (
        <main
            id="testpanel"
            className={
                toggle?.toggle && isInPhoneOrTablet()
                    ? 'test-panel-wrapper sidenavopen'
                    : 'test-panel-wrapper'
            }
        >
            {connection === 'offline' ? (
                <InternetIssue
                    message={t(
                        'There seems to be a problem with your Internet Network Connection',
                    )}
                />
            ) : null}
            {connection === 'online' ? (
                <PopUpWrapper
                    isToast={true}
                    toastType={'success'}
                    width={'281px'}
                    height={'81px'}
                    top={'auto'}
                    right={'auto'}
                    closeButtonBackground={'#000'}
                >
                    <div className="status-container">
                        <img src={offline} alt="offline" />
                        <div>
                            <div className="status-text">
                                <span className="status-type">
                                    {t('Connected!')}
                                </span>
                                <span className="status-message">
                                    {t('You are back online')}
                                </span>
                            </div>
                        </div>
                    </div>
                </PopUpWrapper>
            ) : null}

            <div className="test-panel">
                <QuestionHeader
                    header={testpanel.questionset}
                    handleClick={handleSectionClick}
                    active={active}
                    current_language={current_language}
                    instruction={instructions.testData}
                    sectionType="testpanel"
                    handleGTagLogs={handleGTagLogs}
                />
                <div className="tab-container-wrapper">
                    <Question
                        isPreview={isPreview}
                        question={testpanel.questionset}
                        active={active}
                        setActive={setActive}
                        setDisconnectTime={setDisconnectTime}
                        handleGTagLogs={handleGTagLogs}
                        tabSwitchCount={tabSwitchCount}
                    />
                </div>
            </div>
            {showGoBackPopUp ? (
                <PopUpWrapper
                    style={
                        isInPhoneOrTablet()
                            ? { width: '85%', transition: 'none' }
                            : {
                                  width: '62%',
                                  height: 'auto',
                                  transition: 'none',
                              }
                    }
                    callback={setShowGoBackPopUp}
                    // callback2={setDontShowPop}
                    isToast={false}
                >
                    <CloseTestConfirmation
                        isPreview={isPreview}
                        isMock={isMock}
                        handleGTagLogs={handleGTagLogs}
                        handleSubmit={handleSubmit}
                        setShowGoBackPopUp={setShowGoBackPopUp}
                        showGoBackPopUp={showGoBackPopUp}
                    />
                </PopUpWrapper>
            ) : null}
            {showWarningPopup ? (
                <PopUpWrapper hideCloseButton={true}>
                    <Warning
                        tabSwitchCount={tabSwitchCount}
                        onClose={() => setShowWarningPopup(false)}
                    />
                </PopUpWrapper>
            ) : null}
        </main>
    )
}

export default TestPanelUI
